import "./index.css";

import { Composition } from "remotion";
import { BarbershopAd, T } from "./bsad/BarbershopAd";
import { PangkasinPromo, PangkasinStory } from "./PangkasinPromo";
import { PangkasinDarkPromo } from "./PangkasinKasir";
import { PangkasinNeoBrutal } from "./PangkasinNeoBrutal";
import { HelloRemotion } from "./compositions/HelloRemotion";
import { CarrooPromo } from "./compositions/CarrooPromo";
import { StoryFormat } from "./compositions/StoryFormat";

export const RemotionRoot: React.FC = () => {
  return (
    <>
      {/* Promo Pangkasin 16:9 NEO-BRUTALISM — 1920x1080, 30fps, 1800 frame (60s), 6 scene × 300 frame */}
      <Composition
        id="PangkasinPromo169"
        component={PangkasinNeoBrutal}
        durationInFrames={1800}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* Versi lama (dark slate) — disimpan sebagai arsip */}
      <Composition
        id="PangkasinDark169"
        component={PangkasinDarkPromo}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* Promo Pangkasin — barbershop.carroo.my.id */}
      <Composition
        id="PangkasinPromo"
        component={PangkasinPromo}
        durationInFrames={590}
        fps={30}
        width={1080}
        height={1080}
      />
      <Composition
        id="PangkasinStory"
        component={PangkasinStory}
        durationInFrames={590}
        fps={30}
        width={1080}
        height={1920}
      />

      {/* contoh/template lama */}
      <Composition
        id="HelloRemotion"
        component={HelloRemotion}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{ title: "Hello Remotion", subtitle: "remotion.carroo.my.id" }}
      />
      <Composition
        id="CarrooPromo"
        component={CarrooPromo}
        durationInFrames={240}
        fps={30}
        width={1080}
        height={1080}
        defaultProps={{ brand: "CARROO", tagline: "Konten video otomatis, tanpa editor." }}
      />
      <Composition
        id="StoryFormat"
        component={StoryFormat}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{ headline: "REELS / STORY", sub: "1080 x 1920 • 6s" }}
      />
      {/* Iklan POS barbershop — 1080x1920 (vertical/reels) NEOBRUTALISM
          30fps, 900 frame (30 detik), 5 scene + 2 fitur per scene besar */}
      <Composition
        id="BarbershopPOSAd"
        component={BarbershopAd}
        durationInFrames={T.total}
        fps={30}
        width={1080}
        height={1920}
      />
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
